module.exports = __webpack_public_path__ + "img/redbear_logo.4ae82147.png";